// eslint-disable-next-line import/prefer-default-export
export const loginDetailsSelector = (state) => state.app.loginDetails;
export const getUserDetailsSelector = (state) => state.app.userDetails;
export const getMenuDetailsSelector = (state) => state.app.menuDetails;
export const getCompanyDetailsSelector = (state) => state.app.companyDetails;
export const profileImageDetailsSelector = (state) =>
  state.app.profileImageDetails;
export const getRoleAccessDetailsSelector = (state) =>
  state.app.roleAccessDetails;
export const getRoleAccessKeySelector = (state) => state.app.roleAccessKey;

export const getAccountListSelector = (state) => state.app.accountList;
export const getCurrentAccDetailsSelector = (state) => state.app.selectedAccDetails;
export const isAccountRefreshSelector = (state) => state.app.isAccRefresh;
export const offerListSelector = (state) => state.app.offerList;
export const billersListSelector = (state) => state.app.billersList;
export const getLanguageSelector= (state)=>state.app.language;
export const getMenuListSelector = (state) => state.app.menuList
